<template>
  <div v-if="order" class="od-summary-card">
    <h3 class="od-summary-title">
      <a-icon type="calculator" style="color:#94a3b8;" />
      Ringkasan Pembayaran
    </h3>

    <div>
      <div class="od-summary-row">
        <span class="od-summary-label">Subtotal Produk</span>
        <span class="od-summary-value">{{ toCurrency(order.sub_total) }}</span>
      </div>

      <div v-if="shippingCost > 0" class="od-summary-row">
        <span class="od-summary-label">Biaya Pengiriman</span>
        <span class="od-summary-value">{{ toCurrency(shippingCost) }}</span>
      </div>

      <div v-if="insuranceCost && insuranceCost > 0" class="od-summary-row">
        <span class="od-summary-label">Biaya Asuransi</span>
        <span class="od-summary-value">{{ toCurrency(insuranceCost) }}</span>
      </div>

      <div v-if="order.payment_fee > 0" class="od-summary-row">
        <span class="od-summary-label">Biaya Platform</span>
        <span class="od-summary-value">{{ toCurrency(order.payment_fee) }}</span>
      </div>

      <div v-if="order.loyalty_usage" class="od-summary-row">
        <span class="od-summary-label">Koin Digunakan</span>
        <span class="od-summary-value" style="color:#d97706;">-{{ order.loyalty_usage }}</span>
      </div>

      <div v-if="(discountTransaction && discountTransaction.length) || (voucherUsed && voucherUsed.length)" class="od-promo-section">
        <div class="od-promo-header">
          <a-icon type="tag" style="color:#e11d48;" />
          Promo &amp; Voucher
        </div>
        <div v-for="promo in discountTransaction" :key="promo.name" class="od-promo-row">
          <span class="od-promo-name">{{ promo.name }}</span>
          <span class="od-promo-amount">-{{ toCurrency(promo.discount || 0) }}</span>
        </div>
        <div v-for="(v, idx) in voucherUsed" :key="idx" class="od-promo-row">
          <span class="od-promo-name">{{ v.voucher_code || 'Voucher' }}</span>
          <span class="od-promo-amount">-{{ toCurrency(v.discount_amount || v.value || 0) }}</span>
        </div>
      </div>

      <hr class="od-summary-divider" />
      <div class="od-summary-row">
        <span class="od-summary-total-label">Total</span>
        <span class="od-summary-total-value">{{ toCurrency(order.gross_total) }}</span>
      </div>

      <div v-if="order.payment_data && order.payment_data.mix_payment_method_id" style="margin-top:16px;padding-top:16px;border-top:1px solid #f1f5f9;">
        <div class="od-summary-row">
          <span class="od-summary-label" style="font-size:12px;">Limit Kredit Terpakai</span>
          <span class="od-summary-value" style="font-size:12px;">{{ toCurrency(order.payment_data.credit_limit_usage) }}</span>
        </div>
        <div class="od-summary-row">
          <span class="od-summary-label" style="font-size:12px;">Sisa Pembayaran</span>
          <span class="od-summary-value" style="font-size:12px;color:#f97316;">{{ toCurrency(order.gross_total - order.payment_data.credit_limit_usage) }}</span>
        </div>
      </div>

      <div v-if="isGuest" style="display:flex;justify-content:space-between;align-items:center;margin-top:16px;padding-top:16px;border-top:1px solid rgba(241,245,249,0.5);">
        <span style="font-size:11px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:0.1em;">Email</span>
        <span style="font-size:13px;font-weight:700;color:#0f172a;overflow:hidden;text-overflow:ellipsis;max-width:160px;">
          {{ order.customer_email || (order.billing_data && order.billing_data.email) || order.email || '-' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderSummarySide',
  props: {
    order: { type: Object, default: null },
    isGuest: { type: Boolean, default: false },
    shippingCost: { type: Number, default: 0 },
    insuranceCost: { type: Number, default: 0 },
    discountTransaction: { type: Array, default: () => [] },
    discountProduct: { type: Array, default: () => [] },
    voucherUsed: { type: Array, default: () => [] },
    isPaid: { type: Boolean, default: false },
    toCurrency: { type: Function, required: true },
  },
}
</script>
